import { LocationType } from '../../common/api/spidertracks-sdk/types/PointOfInterest';

export const getLocationTypeNameById = (
  id: number | undefined,
  allLocationTypes: LocationType[]
) => {
  if (id === undefined) return undefined;
  return allLocationTypes.find(locationType => locationType.id === id)?.description;
};

export const getLocationTypeCodeById = (id: number | undefined, locationTypes: LocationType[]) => {
  if (id === undefined) return undefined;
  return locationTypes.find(locationType => locationType.id === id)?.airportType;
};

export const getLocationTypeDisplayName = (locationType: LocationType) =>
  `${locationType.description} (${locationType.abbreviation})`;

const POI_CODE_REGEX = /^[A-Z0-9]+$/;
export const POI_CODE_MAX_LENGTH = 10;
export const POI_NAME_MAX_LENGTH = 50;

export const getPoiCodeValidationErrorMessage = (value: string) => {
  if (!value || value.trim() === '') {
    return 'Location code is required';
  }
  if (value.length > POI_CODE_MAX_LENGTH) {
    return `Location code must be less than ${POI_CODE_MAX_LENGTH} characters`;
  }
  if (!POI_CODE_REGEX.test(value)) {
    return 'Location code must be alphanumeric';
  }
};

export const getPoiNameValidationErrorMessage = (value: string) => {
  if (!value || value.trim() === '') {
    return 'Location name is required';
  }
  if (value.length > POI_NAME_MAX_LENGTH) {
    return `Location name must be less than ${POI_NAME_MAX_LENGTH} characters`;
  }
};
